import { Button, Input, Modal, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useLoading } from '../../../lib/hooks/useLoading'
import { useAuthStore } from '../../../stores/auth'

const EnterCodeWrapper = styled.div`
  padding-bottom: 20px;
`

export function DisableTwoFactor({
  isVisible,
  onCancel,
}: {
  isVisible: boolean
  onCancel: () => void
}): React.ReactNode {
  const { t } = useTranslation()
  const [isLoading, withLoading] = useLoading()
  const [code, setCode] = useState<string>('')
  const [handleDisableTwoFactor] = useAuthStore((state) => [state.handleDisableTwoFactor])

  useEffect(() => {
    if (!isVisible) setCode('')
  }, [isVisible])

  async function handleDisable(): Promise<void> {
    const success = await withLoading(handleDisableTwoFactor(code))
    if (success) onCancel()
  }

  return (
    <Modal
      title={t('widgets.account.twoFactor.disable.title')}
      open={isVisible}
      onCancel={onCancel}
      maskClosable={false}
      destroyOnHidden
      centered
      footer={
        <Button
          disabled={code.length !== 6 || isLoading}
          loading={isLoading}
          type="primary"
          onClick={handleDisable}
          size="large"
        >
          {t('actions.disable')}
        </Button>
      }
    >
      <EnterCodeWrapper>
        <Typography.Paragraph>{t('widgets.account.twoFactor.disable.enterCode')}</Typography.Paragraph>
        <Input
          size="large"
          value={code}
          onChange={(event) => setCode(event.target.value)}
          style={{ textAlign: 'center', fontWeight: '500' }}
          maxLength={6}
          placeholder={t('placeholders.twoFactor')}
        />
      </EnterCodeWrapper>
    </Modal>
  )
}
